module.exports = __webpack_public_path__ + "img/dreamweaver.95db99ec.png";